var _defs, _circle, _circle2, _circle3, _circle4, _circle5, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "mars",
    cx: "35%",
    cy: "30%",
    r: "82%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ff9a6b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55%",
    stopColor: "#d9482b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#781f10"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 96,
    fill: "url(#mars)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 78,
    r: 13,
    fill: "#6a1c0e",
    opacity: 0.55
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 132,
    cy: 118,
    r: 19,
    fill: "#59170b",
    opacity: 0.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 150,
    r: 8,
    fill: "#59170b",
    opacity: 0.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 70,
    r: 6,
    fill: "#6a1c0e",
    opacity: 0.45
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 62 h48 q12 8 10 18",
    fill: "none",
    stroke: "#ffc4a0",
    strokeOpacity: 0.6,
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M120 152 h34",
    fill: "none",
    stroke: "#ffc4a0",
    strokeOpacity: 0.5,
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMars);
export default __webpack_public_path__ + "static/media/mars.189fb60bdc33b61798214e61c515a67d.svg";
export { ForwardRef as ReactComponent };